import script from "./procureContractDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./procureContractDetail.vue?vue&type=script&setup=true&lang=js"

import "./procureContractDetail.vue?vue&type=style&index=0&id=4315a642&lang=less"

const __exports__ = script;

export default __exports__